<template>
  <div class="typebox">
    <div v-if="showSticker" class="sticker d-flex flex-column">
      <div class="sticker-header d-flex align-items-start">
        <div class="d-flex flex-wrap">
          <b-button class="p-0 rounded-0 px-2" @click="switchStickerSet">
            <img
              v-if="isSticker"
              src="data:image/svg+xml;base64,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"
            />
            <img
              v-else
              src="data:image/svg+xml;base64,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"
            />
          </b-button>

          <template v-for="(i, idx) in itemSets">
            <b-button
              :key="i"
              variant="link"
              :class="['p-0', 'rounded-0', setIndex == idx && 'active']"
              @click="setIndex = idx"
            >
              <img
                v-if="isSticker"
                :src="getImage(`sticker/tab/${i}_tab.png`)"
              />
              <img v-else :src="getImage(`sticon/tab/${i}_tab.png`)" />
            </b-button>
          </template>
        </div>
        <button
          class="btn btn-link p-2 text-dark ml-auto"
          @click="showSticker = !showSticker"
        >
          <i class="fa fa-times" aria-hidden="true"></i>
        </button>
      </div>
      <div class="sticker-body">
        <template
          v-for="(j, jdx) in items.filter((x) => {
            return x.set == itemSets[setIndex];
          })"
        >
          <b-button
            :key="jdx"
            variant="link"
            :class="['p-1', 'rounded-0', isSticker ? 'stk' : 'emoji']"
            @click="
              isSticker ? insertSticker(j.set, j.id) : insertEmoji(j.set, j.id)
            "
          >
            <img v-if="isSticker" :src="getImage(`sticker/${j.id}_S.png`)" />
            <img v-else :src="getImage(`sticon/${j.set}/${j.id}_S.png`)" />
          </b-button>
        </template>
      </div>
    </div>

    <div class="d-flex p-2 position-relative">
      <button
        v-if="canSticker"
        class="btn btn-link px-2 text-dark align-self-start"
        @click="toggleSticker"
      >
        <i class="fa fa-smile-o" aria-hidden="true"></i>
      </button>
      <button
        v-if="canImage"
        class="btn btn-link px-2 text-dark align-self-start upload-button"
      >
        <i class="fa fa-picture-o" aria-hidden="true"></i>
        <b-form-file
          accept="image/jpeg, image/png, image/gif"
          @change="uploadImage"
          plain
          placeholder="尚未選擇檔案"
          browse-text="瀏覽"
        />
      </button>
      <button
        v-if="canAttach"
        class="btn btn-link px-2 text-dark align-self-start upload-button"
      >
        <i class="fa fa-paperclip" aria-hidden="true"></i>
        <b-form-file
          accept="image/jpeg, image/png, image/gif"
          @change="uploadFile"
          plain
          placeholder="尚未選擇檔案"
          browse-text="瀏覽"
        />
      </button>

      <b-dropdown
        dropup
        class="p-0 btn btn-link align-self-start"
        variant=" p-2"
        no-caret
      >
        <template #button-content>
          <i class="fa fa-paperclip" aria-hidden="true"></i>
        </template>
        <b-dropdown-item
          href="#"
          link-class="d-flex justify-content-between align-items-center"
          ><span>單檔</span><i class="fa fa-paperclip" aria-hidden="true"></i
        ></b-dropdown-item>
        <b-dropdown-item
          href="#"
          link-class="d-flex justify-content-between align-items-center"
          ><span>多檔</span
          ><img
            src="@/assets/images/liff/chatbox/paperclip-2.png"
            width="18"
            height="18"
        /></b-dropdown-item>
      </b-dropdown>

      <div
        class="flex-fill align-self-stretch position-relative message-wrapper"
      >
        <textarea
          placeholder="輸入留言"
          class="p-2 pr-5 message"
          @input="inputMessage"
          @click="changeCaret"
          @keyup="changeCaret"
          rows="1"
          ref="message"
        >
        </textarea>
        <div class="message-overlay p-2 pr-5" v-html="parseMessage"></div>
        <button class="btn send px-2" type="submit">
          <svg
            width="21"
            height="18"
            viewBox="0 0 21 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M19.17 6.22991L5.17001 0.449907C4.64029 0.230693 4.05884 0.167851 3.49451 0.26882C2.93018 0.369788 2.4066 0.630339 1.98575 1.01963C1.5649 1.40891 1.2644 1.91064 1.11983 2.4654C0.975262 3.02016 0.992675 3.60473 1.17001 4.14991L2.71001 8.99991L1.13001 13.8499C0.947881 14.3973 0.927422 14.9855 1.07108 15.5442C1.21475 16.1029 1.51644 16.6083 1.94001 16.9999C2.48465 17.505 3.19729 17.79 3.94001 17.7999C4.33474 17.7996 4.72554 17.7215 5.09001 17.5699L19.14 11.7899C19.6872 11.5623 20.1547 11.1778 20.4836 10.6848C20.8125 10.1919 20.988 9.61252 20.988 9.01991C20.988 8.42729 20.8125 7.84795 20.4836 7.35497C20.1547 6.862 19.6872 6.47747 19.14 6.24991L19.17 6.22991ZM4.36001 15.6999C4.18361 15.7727 3.99007 15.7934 3.80225 15.7598C3.61442 15.7261 3.44015 15.6394 3.30001 15.5099C3.168 15.3838 3.07304 15.2239 3.02545 15.0476C2.97785 14.8713 2.97943 14.6854 3.03001 14.5099L4.49001 9.99991H18.22L4.36001 15.6999ZM4.49001 7.99991L3.00001 3.52991C2.94943 3.35446 2.94785 3.16851 2.99545 2.99222C3.04304 2.81594 3.138 2.65606 3.27001 2.52991C3.36412 2.43118 3.47742 2.35275 3.60296 2.29944C3.7285 2.24613 3.86362 2.21906 4.00001 2.21991C4.13406 2.22016 4.26669 2.24737 4.39001 2.29991L18.22 7.99991H4.49001Z"
              fill="#09101D"
            />
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import stickers from "./stickers.json";
import emojis from "./emojis.json";
import https from "../../../apis/https";
const getSticker = (path) => require(`./${path}`);

export default {
  data() {
    return {
      items: stickers,
      setIndex: 0,
      isSticker: true,
      showSticker: false,
      selectionStart: 0,
      selectionEnd: 0,
      displayMessage: "",
      message: {
        type: "text",
        text: "",
        emojis: [],
      },
    };
  },
  props: {
    canAttach: {
      default: false,
      type: Boolean,
    },
    canImage: {
      default: false,
      type: Boolean,
    },
    canSticker: {
      default: false,
      type: Boolean,
    },
  },
  methods: {
    toggleSticker: function () {
      this.showSticker = !this.showSticker;
      this.$refs.message.focus();
    },
    switchStickerSet: function () {
      this.setIndex = 0;
      this.isSticker = !this.isSticker;
      this.items = this.isSticker ? stickers : emojis;
      this.$refs.message.focus();
    },
    changeCaret: function (e) {
      this.selectionEnd = e.target.selectionEnd;
      this.selectionStart = e.target.selectionStart;
    },
    inputMessage: function (e) {
      const textarea = e.target;
      const wrapper = textarea.parentNode;
      textarea.style.height = `0`;
      textarea.style.height = `${textarea.scrollHeight}px`;
      wrapper.style.height = `${wrapper.scrollHeight}px`;

      if (
        (e.inputType == "deleteContentBackward" ||
          e.inputType == "deleteContentForward") &&
        this.message.emojis.length >= this.message.text.split("　").length - 1
      ) {
        var indices = [];
        for (var i = 0; i < this.message.text.length; i++) {
          if (this.message.text[i] === "　") indices.push(i);
        }

        for (var idx = 0; idx < indices.length; idx++) {
          if (
            e.inputType == "deleteContentBackward" &&
            this.selectionStart - 1 <= indices[idx] &&
            this.selectionEnd - 1 >= indices[idx]
          ) {
            this.message.emojis.splice(idx, 1);
          } else if (
            e.inputType == "deleteContentForward" &&
            this.selectionStart <= indices[idx] &&
            this.selectionEnd >= indices[idx]
          ) {
            this.message.emojis.splice(idx, 1);
          }
        }
      }

      if (e.data == "　") {
        this.insertEmoji(null, null);
      }

      this.message.text = e.target.value;

      this.$emit("input", this.outputMessage);
    },
    insertSticker: function (set, id) {
      this.$emit("insertSticker", {
        type: "sticker",
        packageId: set,
        stickerId: id,
      });
    },
    insertEmoji: function (set, id) {
      let insertIndex = this.message.emojis.length;

      var indices = [];
      for (var i = 0; i < this.message.text.length; i++) {
        if (this.message.text[i] === "　") indices.push(i);
      }

      for (var idx = 0; idx < indices.length; idx++) {
        if (this.selectionEnd <= indices[idx]) {
          insertIndex = idx;
          break;
        }
      }

      this.message.text =
        this.message.text.slice(0, this.selectionEnd) +
        "　" +
        this.message.text.slice(this.selectionEnd);

      this.message.emojis.splice(insertIndex, 0, {
        productId: set,
        emojiId: id,
      });

      this.selectionEnd += 1;
      this.selectionStart += 1;

      this.$emit("input", this.outputMessage);
      this.$refs.message.value = this.message.text;
      this.$refs.message.focus();
    },
    getImage: function (path) {
      return getSticker(path);
    },
    async uploadImage(e) {
      try {
        let form = new FormData();
        form.append("image", e.target.files[0]);
        const { data } = await https.post(`general/images/upload`, form);
        this.$emit("insertImage", data);
      } catch (error) {
        console.log("error", error);
        this.$swal("圖片上傳失敗", "", "danger");
      }
    },
    async uploadFile(e) {
      try {
        let form = new FormData();
        form.append("image", e.target.files[0]);
        const { data } = await https.post(`general/files/upload`, form);

        this.$emit("insertFile", data);
      } catch (error) {
        console.log("error", error);
        this.$swal("檔案上傳失敗", "", "danger");
      }
    },

    send: function () {},
  },
  computed: {
    itemSets: function () {
      const set = new Set(this.items.map((i) => i.set));
      return [...set];
    },
    parseMessage: function () {
      let r = "";

      let textArray = this.message.text.split("　");

      if (textArray.length > 1) {
        textArray.forEach((el, idx) => {
          if (
            this.message.emojis[idx] != undefined &&
            this.message.emojis[idx].productId
          ) {
            r +=
              el +
              "<span class='message-emoji' style='background-image: url(" +
              this.getImage(
                `sticon/${this.message.emojis[idx].productId}/${this.message.emojis[idx].emojiId}_S.png`
              ) +
              ")'>　</span>";
          } else {
            r += "　";
          }
        });

        return r;
      } else {
        return this.message.text;
      }
    },
    outputMessage: function () {
      let r = this.message.text;
      if (this.message.emojis.length > 0) {
        var indices = [];
        for (var i = 0; i < this.message.text.length; i++) {
          if (this.message.text[i] === "　") indices.push(i);
        }

        indices.forEach((el, idx) => {
          if (this.message.emojis[idx].emojiId != null) {
            this.message.emojis[idx].index = el;
          }
        });

        this.message.emojis.forEach((el) => {
          if (el.index != undefined && r[el.index] == "　") {
            r = r.substring(0, el.index) + "$" + r.substring(el.index + 1);
          }
        });

        return {
          type: this.message.type,
          text: r,
          emojis: this.message.emojis.filter((el) => {
            return el.emojiId != null;
          }),
        };
      } else return this.message;
    },
  },
};
</script>
<style lang="scss" scoped>
.sticker {
  height: 200px;
  background-color: white;
  width: 100%;

  border-top: solid 1px #ccc;
  border-bottom: solid 1px #ccc;

  .sticker-header {
    background-color: #eee;
    button.active {
      background-color: #ddd;
    }
    img {
      max-height: 40px;
      max-width: 40px;
    }
  }

  .sticker-body {
    overflow-y: auto;

    width: min-content;
    min-width: 100%;

    img {
      max-height: 100%;
      max-width: 100%;
    }

    button {
      &:hover {
        transform: scale(1.1);
      }

      &.stk {
        height: 80px;
        width: 80px;
      }
      &.emoji {
        height: 40px;
        width: 40px;
      }
    }
  }
}

.typebox {
  position: relative;
  min-width: 100%;
  width: fit-content;

  .message-wrapper {
    height: 43px;
    .message {
      font-size: 1rem;
      line-height: 1.5;
      position: absolute;
      font-weight: normal;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      overflow: hidden;
      z-index: 1;
      height: fit-content;
      background: none;
    }

    .message-overlay {
      color: transparent;
      position: absolute;
      font-weight: normal;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      font-size: 1rem;
      line-height: 1.5;
      height: 100%;
      white-space: pre-line;
      border: solid 1px transparent;
    }
    .send {
      position: absolute;
      right: 0px;
      top: 5px;
      z-index: 1;
    }
  }
}

.upload-button {
  position: relative;
  overflow: hidden;
  max-width: 35px;
  max-height: 30px;

  .form-control-file {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    opacity: 0;
    z-index: 1;
    cursor: pointer;
  }
}
</style>
<style lang="scss">
.message-selectionEnd {
  -webkit-user-select: text !important;
  -moz-user-select: text !important;

  user-select: text;
  position: absolute;
  display: inline-block;
  width: 1px !important;
  height: 1.5em;
}

.message-emoji {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: 1px center;
}
</style>
